import { DateFormat, formatCurrency, formatDate } from "../../../utils";
import { MISSING_VALUE } from "./constants";
import { settledAtOf } from "./investmentGoalStatus";
import { PastInvestmentGoalRowProps } from "./types";
import {
  CardTop,
  GoalName,
  PastAmount,
  PastItem,
  PastLine,
  StatusChip,
} from "./styles";
import Button, { ButtonTypes } from "../../../components/Button";

export const PastInvestmentGoalRow = ({
  goal,
  onDelete,
}: PastInvestmentGoalRowProps) => {
  const isReached = goal.reachedAt !== null;
  const chipLabel = isReached ? "Reached" : "Archived";
  const chipTone = isReached ? "success" : "info";
  const settledAt = settledAtOf(goal);
  const settledAmount = goal.reachedAmount ?? goal.archivedAmount;
  const settledAmountText =
    settledAmount === null ? MISSING_VALUE : formatCurrency(settledAmount);
  const settledDate = settledAt
    ? formatDate(settledAt, DateFormat.DMY_SPACE)
    : MISSING_VALUE;
  const deleteLabel = `Delete ${goal.name}`;

  return (
    <PastItem data-testid="past-investment-goal">
      <CardTop>
        <GoalName>{goal.name}</GoalName>
        <StatusChip $tone={chipTone}>{chipLabel}</StatusChip>
      </CardTop>
      <PastLine>
        <span>Target {formatCurrency(goal.targetAmount)}</span>
        <PastAmount>{settledAmountText}</PastAmount>
        <span>on {settledDate}</span>
        <Button
          type={ButtonTypes.link}
          size="small"
          tone="danger"
          aria-label={deleteLabel}
          onClick={() => onDelete(goal)}
        >
          Delete
        </Button>
      </PastLine>
    </PastItem>
  );
};
